import React, { useRef } from 'react';
import { Box, Typography, Link } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import SettingsPopover, { ISettingsPopoverHandles } from '../setup/SettingsPopover';
import { useConfigurationStore } from '../../stores/ConfigStore';

const LinkButton = styled(Link)(({ theme }) => ({
  color: theme.palette.text.primary,
  padding: "0 0 0 5px",
  textTransform: 'none',
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.body2.fontSize,
}));

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const theme = useTheme();
  const location = useLocation();
  const { configuration } = useConfigurationStore();
  const popoverRef = useRef<ISettingsPopoverHandles>(null);

  const openPopover = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    popoverRef.current?.handleClick(event);
  };

  const isRootPath = location.pathname === '/';

  return (
    <Box display="flex" justifyContent="center" alignItems="center" py={2} sx={{
      backgroundColor: theme.palette.background.paper,
    }}>
      <Typography variant="body2" sx={{
        color: theme.palette.text.primary,
        textAlign: "center"
      }}>
        &copy; {currentYear} - CASABLANCA hotelsoftware GmbH
        {!isRootPath && (
          <LinkButton
            onClick={openPopover}
            underline="none"
          >
            / Einstellungen
          </LinkButton>
        )}
      </Typography>
      <SettingsPopover ref={popoverRef} tenantId={configuration.setup.tenantId} deviceName={configuration.setup.deviceName} placeholderUrl={configuration.setup.placeholderUrl}/>
    </Box>
  );
};

export default Footer;
